// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/cameraOff.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ConnectionComponent.module.css */

.ConnectionComponent_buttonNormal__cH6JY {
  font-family: "Syne", sans-serif;
  font-size: 2.5vh;
  padding: 0.7rem 4rem;

  border: none;
  border-radius: 0.5rem;
  background-color: #6616cd;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ConnectionComponent_controlButtons__Yem4f {
  display: flex;
  position: relative;
}

.ConnectionComponent_iconButton__5vLxn {
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 5px;
  position: relative;
  z-index: 999;
}

.ConnectionComponent_buttonNormal__cH6JY:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.ConnectionComponent_buttonHover__ZkhwJ {
  background-color: #2563eb;
  /* blue-600 */
}

.ConnectionComponent_videoContainer__QpBV7 {
  width: 65vw;
  height: 60vh;
  margin-right: 1rem;
}

.ConnectionComponent_firstStream__CPnwv {
  width: 30vw;
  height: 60vh;
  object-fit: cover;
  margin-left: 2vh;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
  border-radius: 30px;
  transform: scaleX(-1);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

.ConnectionComponent_secondStream__9Veel {
  width: 30vw;
  height: 60vh;
  object-fit: cover;
  margin-left: 2vh;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
  border-radius: 30px;
  transform: scaleX(-1);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

.ConnectionComponent_noMirror__ZSQFf {
  transform: none !important;
  object-fit: contain !important;
}

.ConnectionComponent_textCenter__sgZUG {
  text-align: center;
  margin-top: 8px;
}

.ConnectionComponent_controlButtonsContainer__qdMEi {
  display: flex;
}

.ConnectionComponent_connectionStatus__FU310 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4vh;
  width: 95%;
  font-family: "Syne", sans-serif;
}

.ConnectionComponent_connectionStatusText__J39Ne {
  margin-left: 5%;
  margin-right: 5%;
}

.ConnectionComponent_connectionStatusContainer__3zUge {
  width: 20%;
}

/* More Options Dropdown Styles */
.ConnectionComponent_moreOptionsDropdown__ZmEZ9 {
  position: absolute;
  bottom: 55px;
  right: 0;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 300px;
  padding: 15px;
  z-index: 1000;
  font-family: "Syne", sans-serif;
}

/* Main Menu Buttons */
.ConnectionComponent_moreOptionsButtons__08H0- {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.ConnectionComponent_optionButton__1qPBE {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-radius: 8px;
  padding: 10px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1 1;
  margin: 0 5px;
}

.ConnectionComponent_optionButton__1qPBE svg {
  margin-bottom: 5px;
  color: #6616cd;
}

.ConnectionComponent_optionButton__1qPBE:hover {
  background-color: #f8f8f8;
}

.ConnectionComponent_optionButton__1qPBE.ConnectionComponent_active__QK7OP {
  background-color: #f0f0f0;
  font-weight: bold;
}

/* Option Panel for Voice/Screen */
.ConnectionComponent_optionPanel__zho-m {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-top: 15px;
  overflow: hidden;
}

.ConnectionComponent_optionPanelHeader__NG\\+zW {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #eee;
}

.ConnectionComponent_optionPanelHeader__NG\\+zW h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.ConnectionComponent_closeButton__hRa4K {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #777;
}

.ConnectionComponent_closeButton__hRa4K:hover {
  color: #333;
}

.ConnectionComponent_optionPanelContent__f6FW0 {
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ConnectionComponent_filterOption__e5viz {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f8f8f8;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.ConnectionComponent_filterOption__e5viz:hover {
  background-color: #f0f0f0;
}

.ConnectionComponent_filterOption__e5viz.ConnectionComponent_active__QK7OP {
  background-color: #6616cd;
  color: white;
  border-color: #6616cd;
}

.ConnectionComponent_mobileNotice__YoqHT {
  padding: 15px;
  background-color: #fff3cd;
  color: #856404;
  border-radius: 5px;
  border: 1px solid #ffeeba;
  text-align: center;
  font-size: 14px;
  line-height: 1.4;
}

/* Typing Indicator Styles */
.ConnectionComponent_typingIndicator__5F7L4 {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #f1f1f1;
  border-radius: 18px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 5px 10px;
  position: relative;
}

.ConnectionComponent_typingDot__vNMVK {
  width: 8px;
  height: 8px;
  margin: 0 2px;
  background-color: #6616cd;
  border-radius: 50%;
  display: inline-block;
  animation: ConnectionComponent_typing-animation__kxORZ 1.4s infinite ease-in-out both;
}

.ConnectionComponent_typingDot__vNMVK:nth-child(1) {
  animation-delay: 0s;
}

.ConnectionComponent_typingDot__vNMVK:nth-child(2) {
  animation-delay: 0.2s;
}

.ConnectionComponent_typingDot__vNMVK:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes ConnectionComponent_typing-animation__kxORZ {

  0%,
  80%,
  100% {
    transform: scale(0.7);
    opacity: 0.5;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* BackgroundFilter container outside of dropdown */
.ConnectionComponent_controlButtons__Yem4f>div[class*="filterPanel"] {
  position: absolute;
  top: -687%;
  right: 0;
  /* z-index: 998; */
  width: 300px;
  /* margin-top: 60px; */
}

/* Add these styles for reactions */
.ConnectionComponent_reactionButton__mKcNq {
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 5px;
  position: relative;
  z-index: 999;
  font-size: 24px;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.ConnectionComponent_reactionButton__mKcNq:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.ConnectionComponent_reactionPanel__UvYxQ {
  position: absolute;
  bottom: 100%;
  right: 0;
  background: white;
  padding: 10px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 8px;
  z-index: 1000;
}

.ConnectionComponent_reactionEmoji__1Qfiu {
  font-size: 24px;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s;
  background: none;
  border: none;
}

.ConnectionComponent_reactionEmoji__1Qfiu:hover {
  background: rgba(102, 22, 205, 0.1);
  transform: scale(1.1);
}

.ConnectionComponent_videoReaction__327uv {
  position: absolute;
  font-size: 72px;
  pointer-events: none;
  animation: ConnectionComponent_float__kAE8A 1.5s ease-out forwards;
  z-index: 1000;
}

@keyframes ConnectionComponent_float__kAE8A {
  0% {
    opacity: 1;
    transform: translateY(0) scale(0.5);
  }

  100% {
    opacity: 0;
    transform: translateY(-100px) scale(1);
  }
}

/* Position adjustments for smaller screens */
@media (max-width: 768px) {
  .ConnectionComponent_videoContainer__QpBV7 {
    position: relative;
    width: 90vw;
    display: flex;
    margin: 0 auto;
  }

  .ConnectionComponent_firstStream__CPnwv {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 30px;
    object-fit: cover;
    /* This ensures the video covers the full area */
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    margin: 0;
  }

  .ConnectionComponent_secondStream__9Veel {
    position: absolute;
    right: 10px;
    /* Adjust the position as needed */
    bottom: 10px;
    /* Adjust the position as needed */
    width: 24vw;
    height: 24vw;
    border-radius: 30px;
    object-fit: cover;
    border: 1px solid white;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    cursor: pointer;
    margin: 0;
  }

  .ConnectionComponent_connectionStatus__FU310 {
    width: 100vw;
    justify-content: center;
  }

  .ConnectionComponent_connectionStatusContainer__3zUge {
    display: none;
  }

  .ConnectionComponent_buttonNormal__cH6JY {
    padding: 0.4rem 1rem;
    font-size: 1.8vh;
  }

  .ConnectionComponent_controlButtonsContainer__qdMEi {
    display: flex;
    width: 88%;
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  /* Mobile styles for More Options dropdown */
  .ConnectionComponent_moreOptionsDropdown__ZmEZ9 {
    width: 250px;
    left: 4rem;
  }

  /* Mobile styles for typing indicator */
  .ConnectionComponent_typingIndicator__5F7L4 {
    padding: 8px 12px;
    margin: 3px 8px;
  }

  .ConnectionComponent_typingDot__vNMVK {
    width: 6px;
    height: 6px;
  }

  .ConnectionComponent_controlButtons__Yem4f>div[class*="filterPanel"] {
    position: absolute;
    width: 250px;
    left: 4rem;
    top: -14.4rem;
    transform: translateY(-50%);
    z-index: 1000;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .ConnectionComponent_videoContainer__QpBV7 {
    width: 95vw;
    height: 50vh;
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-right: 2rem;
  }

  .ConnectionComponent_firstStream__CPnwv {
    width: 45vw;
    height: 50vh;
    object-fit: cover;
    border-radius: 20px;
    transform: scaleX(-1);
    background-size: cover;
    background-position: center;
  }

  .ConnectionComponent_secondStream__9Veel {
    width: 45vw;
    height: 50vh;
    object-fit: cover;
    border-radius: 20px;
    transform: scaleX(-1);
    background-size: cover;
    background-position: center;
  }

  .ConnectionComponent_controlButtonsContainer__qdMEi {
    width: 95%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
  }

  .ConnectionComponent_buttonNormal__cH6JY {
    font-size: 1rem;
    padding: 0.6rem 2rem;
    border-radius: 8px;
  }

  .ConnectionComponent_controlButtons__Yem4f {
    display: flex;
    gap: 0.5rem;
  }

  .ConnectionComponent_iconButton__5vLxn {
    transform: scale(0.9);
  }

  .ConnectionComponent_moreOptionsDropdown__ZmEZ9 {
    position: absolute;
    left: 4rem;
    width: 280px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }

  .ConnectionComponent_optionPanel__zho-m {
    padding: 1rem;
  }

  .ConnectionComponent_optionPanelContent__f6FW0 {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .ConnectionComponent_filterOption__e5viz {
    font-size: 0.9rem;
    padding: 0.5rem;
  }

  .ConnectionComponent_connectionStatusContainer__3zUge {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 1rem;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .ConnectionComponent_connectionStatusText__J39Ne {
    font-size: 0.9rem;
  }

  /* Voice Effects Panel */
  .ConnectionComponent_optionPanelHeader__NG\\+zW {
    padding: 0.8rem;
  }

  .ConnectionComponent_optionPanelHeader__NG\\+zW h3 {
    font-size: 1rem;
  }

  /* Screen Options Panel */
  .ConnectionComponent_optionPanelContent__f6FW0 button {
    width: 100%;
    padding: 0.6rem;
    font-size: 0.9rem;
  }

  .ConnectionComponent_controlButtons__Yem4f>div[class*="filterPanel"] {
    position: absolute;
    top: -720%;
    right: -60%;
    /* z-index: 998; */
    width: 280px;
    /* margin-top: 60px; */
  }
}

.ConnectionComponent_cancelSearchButton__8HMgW {
  background-color: #d62d2d;
  animation: ConnectionComponent_pulse-cancel__\\+xhem 2s infinite;
}

@keyframes ConnectionComponent_pulse-cancel__\\+xhem {
  0% {
    box-shadow: 0 0 0 0 rgba(214, 45, 45, 0.7);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 0 0 10px rgba(214, 45, 45, 0);
    transform: scale(1.03);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(214, 45, 45, 0);
    transform: scale(1);
  }
}

.ConnectionComponent_searchTimer__0Qgsi {
  display: inline-block;
  margin-left: 10px;
  font-size: 0.8em;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 2px 8px;
  font-weight: bold;
  min-width: 50px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Chat/ConnectionComponent.module.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;;EAEpB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,mDAA6C;EAC7C,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,mDAA6C;EAC7C,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,2BAAsB;EAAtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,qFAA0D;AAC5D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;;IAGE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kEAAuC;EACvC,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gDAAgD;IAChD,sCAAsC;IACtC,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kCAAkC;IAClC,YAAY;IACZ,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,sCAAsC;IACtC,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA,4CAA4C;EAC5C;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA,uCAAuC;EACvC;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;EACnB;;EAEA,wBAAwB;EACxB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;EACzB,+DAAmC;AACrC;;AAEA;EACE;IACE,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;IACE,2CAA2C;IAC3C,sBAAsB;EACxB;;EAEA;IACE,wCAAwC;IACxC,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* ConnectionComponent.module.css */\n\n.buttonNormal {\n  font-family: \"Syne\", sans-serif;\n  font-size: 2.5vh;\n  padding: 0.7rem 4rem;\n\n  border: none;\n  border-radius: 0.5rem;\n  background-color: #6616cd;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.controlButtons {\n  display: flex;\n  position: relative;\n}\n\n.iconButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin: 0 5px;\n  position: relative;\n  z-index: 999;\n}\n\n.buttonNormal:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.buttonHover {\n  background-color: #2563eb;\n  /* blue-600 */\n}\n\n.videoContainer {\n  width: 65vw;\n  height: 60vh;\n  margin-right: 1rem;\n}\n\n.firstStream {\n  width: 30vw;\n  height: 60vh;\n  object-fit: cover;\n  margin-left: 2vh;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\n  border-radius: 30px;\n  transform: scaleX(-1);\n  background: url(\"../../assets/cameraOff.png\");\n  background-size: cover;\n  background-position: center;\n}\n\n.secondStream {\n  width: 30vw;\n  height: 60vh;\n  object-fit: cover;\n  margin-left: 2vh;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\n  border-radius: 30px;\n  transform: scaleX(-1);\n  background: url(\"../../assets/cameraOff.png\");\n  background-size: cover;\n  background-position: center;\n}\n\n.noMirror {\n  transform: none !important;\n  object-fit: contain !important;\n}\n\n.textCenter {\n  text-align: center;\n  margin-top: 8px;\n}\n\n.controlButtonsContainer {\n  display: flex;\n}\n\n.connectionStatus {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 4vh;\n  width: 95%;\n  font-family: \"Syne\", sans-serif;\n}\n\n.connectionStatusText {\n  margin-left: 5%;\n  margin-right: 5%;\n}\n\n.connectionStatusContainer {\n  width: 20%;\n}\n\n/* More Options Dropdown Styles */\n.moreOptionsDropdown {\n  position: absolute;\n  bottom: 55px;\n  right: 0;\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  width: 300px;\n  padding: 15px;\n  z-index: 1000;\n  font-family: \"Syne\", sans-serif;\n}\n\n/* Main Menu Buttons */\n.moreOptionsButtons {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.optionButton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  border-radius: 8px;\n  padding: 10px;\n  font-size: 12px;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex: 1;\n  margin: 0 5px;\n}\n\n.optionButton svg {\n  margin-bottom: 5px;\n  color: #6616cd;\n}\n\n.optionButton:hover {\n  background-color: #f8f8f8;\n}\n\n.optionButton.active {\n  background-color: #f0f0f0;\n  font-weight: bold;\n}\n\n/* Option Panel for Voice/Screen */\n.optionPanel {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  margin-top: 15px;\n  overflow: hidden;\n}\n\n.optionPanelHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: #f8f8f8;\n  border-bottom: 1px solid #eee;\n}\n\n.optionPanelHeader h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #333;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #777;\n}\n\n.closeButton:hover {\n  color: #333;\n}\n\n.optionPanelContent {\n  padding: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.filterOption {\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background-color: #f8f8f8;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.filterOption:hover {\n  background-color: #f0f0f0;\n}\n\n.filterOption.active {\n  background-color: #6616cd;\n  color: white;\n  border-color: #6616cd;\n}\n\n.mobileNotice {\n  padding: 15px;\n  background-color: #fff3cd;\n  color: #856404;\n  border-radius: 5px;\n  border: 1px solid #ffeeba;\n  text-align: center;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Typing Indicator Styles */\n.typingIndicator {\n  display: flex;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: #f1f1f1;\n  border-radius: 18px;\n  max-width: fit-content;\n  margin: 5px 10px;\n  position: relative;\n}\n\n.typingDot {\n  width: 8px;\n  height: 8px;\n  margin: 0 2px;\n  background-color: #6616cd;\n  border-radius: 50%;\n  display: inline-block;\n  animation: typing-animation 1.4s infinite ease-in-out both;\n}\n\n.typingDot:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.typingDot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typingDot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing-animation {\n\n  0%,\n  80%,\n  100% {\n    transform: scale(0.7);\n    opacity: 0.5;\n  }\n\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* BackgroundFilter container outside of dropdown */\n.controlButtons>div[class*=\"filterPanel\"] {\n  position: absolute;\n  top: -687%;\n  right: 0;\n  /* z-index: 998; */\n  width: 300px;\n  /* margin-top: 60px; */\n}\n\n/* Add these styles for reactions */\n.reactionButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin: 0 5px;\n  position: relative;\n  z-index: 999;\n  font-size: 24px;\n  padding: 8px;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.reactionButton:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.reactionPanel {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  background: white;\n  padding: 10px;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-bottom: 8px;\n  z-index: 1000;\n}\n\n.reactionEmoji {\n  font-size: 24px;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s;\n  background: none;\n  border: none;\n}\n\n.reactionEmoji:hover {\n  background: rgba(102, 22, 205, 0.1);\n  transform: scale(1.1);\n}\n\n.videoReaction {\n  position: absolute;\n  font-size: 72px;\n  pointer-events: none;\n  animation: float 1.5s ease-out forwards;\n  z-index: 1000;\n}\n\n@keyframes float {\n  0% {\n    opacity: 1;\n    transform: translateY(0) scale(0.5);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translateY(-100px) scale(1);\n  }\n}\n\n/* Position adjustments for smaller screens */\n@media (max-width: 768px) {\n  .videoContainer {\n    position: relative;\n    width: 90vw;\n    display: flex;\n    margin: 0 auto;\n  }\n\n  .firstStream {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 30px;\n    object-fit: cover;\n    /* This ensures the video covers the full area */\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\n    margin: 0;\n  }\n\n  .secondStream {\n    position: absolute;\n    right: 10px;\n    /* Adjust the position as needed */\n    bottom: 10px;\n    /* Adjust the position as needed */\n    width: 24vw;\n    height: 24vw;\n    border-radius: 30px;\n    object-fit: cover;\n    border: 1px solid white;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    cursor: pointer;\n    margin: 0;\n  }\n\n  .connectionStatus {\n    width: 100vw;\n    justify-content: center;\n  }\n\n  .connectionStatusContainer {\n    display: none;\n  }\n\n  .buttonNormal {\n    padding: 0.4rem 1rem;\n    font-size: 1.8vh;\n  }\n\n  .controlButtonsContainer {\n    display: flex;\n    width: 88%;\n    flex-direction: row-reverse;\n    justify-content: space-between;\n  }\n\n  /* Mobile styles for More Options dropdown */\n  .moreOptionsDropdown {\n    width: 250px;\n    left: 4rem;\n  }\n\n  /* Mobile styles for typing indicator */\n  .typingIndicator {\n    padding: 8px 12px;\n    margin: 3px 8px;\n  }\n\n  .typingDot {\n    width: 6px;\n    height: 6px;\n  }\n\n  .controlButtons>div[class*=\"filterPanel\"] {\n    position: absolute;\n    width: 250px;\n    left: 4rem;\n    top: -14.4rem;\n    transform: translateY(-50%);\n    z-index: 1000;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .videoContainer {\n    width: 95vw;\n    height: 50vh;\n    display: flex;\n    justify-content: center;\n    gap: 1rem;\n    margin-right: 2rem;\n  }\n\n  .firstStream {\n    width: 45vw;\n    height: 50vh;\n    object-fit: cover;\n    border-radius: 20px;\n    transform: scaleX(-1);\n    background-size: cover;\n    background-position: center;\n  }\n\n  .secondStream {\n    width: 45vw;\n    height: 50vh;\n    object-fit: cover;\n    border-radius: 20px;\n    transform: scaleX(-1);\n    background-size: cover;\n    background-position: center;\n  }\n\n  .controlButtonsContainer {\n    width: 95%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem;\n  }\n\n  .buttonNormal {\n    font-size: 1rem;\n    padding: 0.6rem 2rem;\n    border-radius: 8px;\n  }\n\n  .controlButtons {\n    display: flex;\n    gap: 0.5rem;\n  }\n\n  .iconButton {\n    transform: scale(0.9);\n  }\n\n  .moreOptionsDropdown {\n    position: absolute;\n    left: 4rem;\n    width: 280px;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n  }\n\n  .optionPanel {\n    padding: 1rem;\n  }\n\n  .optionPanelContent {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n  }\n\n  .filterOption {\n    font-size: 0.9rem;\n    padding: 0.5rem;\n  }\n\n  .connectionStatusContainer {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.4rem 1rem;\n    border-radius: 20px;\n    background: rgba(255, 255, 255, 0.9);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  }\n\n  .connectionStatusText {\n    font-size: 0.9rem;\n  }\n\n  /* Voice Effects Panel */\n  .optionPanelHeader {\n    padding: 0.8rem;\n  }\n\n  .optionPanelHeader h3 {\n    font-size: 1rem;\n  }\n\n  /* Screen Options Panel */\n  .optionPanelContent button {\n    width: 100%;\n    padding: 0.6rem;\n    font-size: 0.9rem;\n  }\n\n  .controlButtons>div[class*=\"filterPanel\"] {\n    position: absolute;\n    top: -720%;\n    right: -60%;\n    /* z-index: 998; */\n    width: 280px;\n    /* margin-top: 60px; */\n  }\n}\n\n.cancelSearchButton {\n  background-color: #d62d2d;\n  animation: pulse-cancel 2s infinite;\n}\n\n@keyframes pulse-cancel {\n  0% {\n    box-shadow: 0 0 0 0 rgba(214, 45, 45, 0.7);\n    transform: scale(1);\n  }\n\n  50% {\n    box-shadow: 0 0 0 10px rgba(214, 45, 45, 0);\n    transform: scale(1.03);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(214, 45, 45, 0);\n    transform: scale(1);\n  }\n}\n\n.searchTimer {\n  display: inline-block;\n  margin-left: 10px;\n  font-size: 0.8em;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 2px 8px;\n  font-weight: bold;\n  min-width: 50px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonNormal": `ConnectionComponent_buttonNormal__cH6JY`,
	"controlButtons": `ConnectionComponent_controlButtons__Yem4f`,
	"iconButton": `ConnectionComponent_iconButton__5vLxn`,
	"buttonHover": `ConnectionComponent_buttonHover__ZkhwJ`,
	"videoContainer": `ConnectionComponent_videoContainer__QpBV7`,
	"firstStream": `ConnectionComponent_firstStream__CPnwv`,
	"secondStream": `ConnectionComponent_secondStream__9Veel`,
	"noMirror": `ConnectionComponent_noMirror__ZSQFf`,
	"textCenter": `ConnectionComponent_textCenter__sgZUG`,
	"controlButtonsContainer": `ConnectionComponent_controlButtonsContainer__qdMEi`,
	"connectionStatus": `ConnectionComponent_connectionStatus__FU310`,
	"connectionStatusText": `ConnectionComponent_connectionStatusText__J39Ne`,
	"connectionStatusContainer": `ConnectionComponent_connectionStatusContainer__3zUge`,
	"moreOptionsDropdown": `ConnectionComponent_moreOptionsDropdown__ZmEZ9`,
	"moreOptionsButtons": `ConnectionComponent_moreOptionsButtons__08H0-`,
	"optionButton": `ConnectionComponent_optionButton__1qPBE`,
	"active": `ConnectionComponent_active__QK7OP`,
	"optionPanel": `ConnectionComponent_optionPanel__zho-m`,
	"optionPanelHeader": `ConnectionComponent_optionPanelHeader__NG+zW`,
	"closeButton": `ConnectionComponent_closeButton__hRa4K`,
	"optionPanelContent": `ConnectionComponent_optionPanelContent__f6FW0`,
	"filterOption": `ConnectionComponent_filterOption__e5viz`,
	"mobileNotice": `ConnectionComponent_mobileNotice__YoqHT`,
	"typingIndicator": `ConnectionComponent_typingIndicator__5F7L4`,
	"typingDot": `ConnectionComponent_typingDot__vNMVK`,
	"typing-animation": `ConnectionComponent_typing-animation__kxORZ`,
	"reactionButton": `ConnectionComponent_reactionButton__mKcNq`,
	"reactionPanel": `ConnectionComponent_reactionPanel__UvYxQ`,
	"reactionEmoji": `ConnectionComponent_reactionEmoji__1Qfiu`,
	"videoReaction": `ConnectionComponent_videoReaction__327uv`,
	"float": `ConnectionComponent_float__kAE8A`,
	"cancelSearchButton": `ConnectionComponent_cancelSearchButton__8HMgW`,
	"pulse-cancel": `ConnectionComponent_pulse-cancel__+xhem`,
	"searchTimer": `ConnectionComponent_searchTimer__0Qgsi`
};
export default ___CSS_LOADER_EXPORT___;
